import { Injectable, Inject, InjectionToken } from '@angular/core';
import type { Patient, RadioEprEventsWithErrorMessage } from 'estensa-module';
import { from } from 'rxjs';

import { AuthData } from '@se/models';

export const ESTENSA_MODULE_PATIENT_FOLDER_SERVICE = new InjectionToken('estensa.module.patient.folder.service');

export interface IPatientFolderServiceNg1 {
    getPatientReports(
        patient: Patient,
        allBUSearch: boolean,
        credentials?: AuthData,
        displayLoadingSpinner?: boolean,
    ): { $promise: Promise<RadioEprEventsWithErrorMessage> };

    getPatientReportsNg2(
        patientId: string,
        allBUSearch: boolean,
        credentials?: AuthData,
        displayLoadingSpinner?: boolean,
    ): { $promise: Promise<RadioEprEventsWithErrorMessage> };
}

@Injectable()
export class NullPatientFolderService implements IPatientFolderServiceNg1 {
    static EMPTY_RESPONSE = {
        displayMessage: '',
        exceptionMessage: '',
        eprEvents: [],
    } as RadioEprEventsWithErrorMessage;

    getPatientReports() {
        return { $promise: Promise.resolve(NullPatientFolderService.EMPTY_RESPONSE) };
    }
    getPatientReportsNg2() {
        return { $promise: Promise.resolve(NullPatientFolderService.EMPTY_RESPONSE) };
    }
}

@Injectable({
    providedIn: 'root',
})
export class EstensaPatientFolderService {
    constructor(
        @Inject(ESTENSA_MODULE_PATIENT_FOLDER_SERVICE) private patientFolderService: IPatientFolderServiceNg1,
    ) {}

    getPatientReports(patient: Patient, displayNgLoadingSpinner = true) {
        return from(
            this.patientFolderService.getPatientReports(patient, false, null, displayNgLoadingSpinner).$promise,
        );
    }

    getPatientReportsNg2(patientId: string, AllBUSearch = false, credentials?: AuthData, displayNgLoadingSpinner = true) {
        return from(
            this.patientFolderService.getPatientReportsNg2(patientId, AllBUSearch, credentials, displayNgLoadingSpinner).$promise,
        );
    }
}
